import UdeskLocales from 'UdeskLocales';
import React, { FC, useMemo } from 'react';
import { Checkbox, message, Space } from 'udesk-ui';
import { CheckboxProps } from 'antd';

export const QA_METHOD = {
    BATCH: 1,
    SINGLE: 0,
};

interface TemplateProps extends Omit<CheckboxProps, 'value' | 'onChange'> {
    /**
     * 空 - 工单
     * 1 - 工单
     * 2 - 通对话
     * 3 - 工单 + 通对话
     */
    value?: number;
    onChange?: (v?: TemplateProps['value']) => void;
    couldEmpty?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, couldEmpty, ...restProps } = props;

    const options = useMemo(
        () => [
            {
                label: /* 工单 */ UdeskLocales['current'].components.ticketRelateQa.index.workOrder,
                value: 1,
            },
            {
                label: /* 通对话 */ UdeskLocales['current'].components.ticketRelateQa.index
                    .dialogue,
                value: 2,
            },
        ],
        []
    );

    const _value =
        !value || value === 1 ? [1] : value === 2 ? [2] : value === 3 ? [1, 2] : undefined;

    return (
        <Space align="baseline">
            <div>
                <span>
                    {/* 检测数据 */}
                    {UdeskLocales['current'].components.ticketRelateQa.index.detectionData}
                </span>
                <span>:</span>
            </div>

            <Checkbox.Group
                options={options}
                value={_value}
                onChange={(v) => {
                    const nv =
                        v.length === options.length
                            ? 3
                            : v.includes(1)
                            ? 1
                            : v.includes(2)
                            ? 2
                            : undefined;

                    if (!couldEmpty && !nv) {
                        message.warning(
                            /* 检测数据不能为空！ */ UdeskLocales['current'].components
                                .ticketRelateQa.index.detectionDataCannotBeEmpty
                        );
                        return;
                    }

                    onChange?.(nv);
                }}
                {...restProps}
            />
        </Space>
    );
};

export default Template;
